module.exports = __webpack_public_path__ + "img/storeinoship.442fc24c.png";